import pDebounce from "p-debounce";

const form = document.querySelector<HTMLFormElement>("form[data-cpd-rebate]");

const calculateClaim = async (): Promise<void> => {
  if (!form) return;
  const body = new FormData(form);
  const response = await fetch("/actions/memberportal/cpd-rebate/calculate", {
    method: "POST",
    body,
  });
  const cpdTotalClaim = document.querySelector(".js-cpd-total-claim");
  if (response.ok) {
    const json = await response.json();
    if (cpdTotalClaim) {
      cpdTotalClaim.innerHTML = json.total;
    }
  } else {
    if (cpdTotalClaim) {
      cpdTotalClaim.innerHTML =
        "There was an error calculating the total claim.";
    }
  }
};

const calculateClaimDebounced = pDebounce(calculateClaim, 750);

["keydown", "input"].forEach((handle) =>
  document.addEventListener(handle, async (event) => {
    if (!form) return;
    if (!(event.target instanceof HTMLElement)) return;
    await calculateClaimDebounced();
  })
);

[
  "freeform-field-table-after-row-added",
  "freeform-field-table-after-remove-row",
].forEach((handle) =>
  form?.addEventListener(handle, async () => await calculateClaimDebounced())
);

(async () => {
  await calculateClaimDebounced();
})();
